<script lang="ts">
  import InfoBox from "./InfoBox.svelte";
  import type { EditImageActor } from "./editImageMachine";
  import { updateField } from "./editImageMachine.js";
  import { AGENTS, type Image, type Rights, type RightsMarker } from "bildebanken-model";

  export let service: EditImageActor;
  export let image: Image;
  export let rightsholderRequired: boolean;
  export let rightsMarker: RightsMarker;

  $: rightsHolder = image.metadata.rights?.rightsHolder?.contact.title;
  $: invalidRightsholder = !rightsHolder && rightsMarker === "Free";

  function onChangeRightsHolder(this: HTMLInputElement) {
    const title = this.value;
    let newRights: Rights;

    if (title) {
      let resId: string | undefined;
      if (title === "NRK") resId = AGENTS.NRK;

      newRights = {
        ...image.metadata.rights,
        rightsHolder: { contact: { title, resId } },
      };
    } else {
      newRights = {
        ...image.metadata.rights,
        rightsHolder: undefined,
      };
    }
    rightsHolder = newRights.rightsHolder?.contact.title;
    updateField(service, "rights", newRights);
  }
</script>

<div style="position: relative; margin-top: 1rem">
  <div>
    <label data-testid="Rettighetshaver" style="width: 35%" for="rightsHolder">
      Rettighetshaver
      <span class={rightsholderRequired ? "" : "hidden"}>*</span>
    </label>
    <InfoBox
      header="Hva er rettighetshaver?"
      link="https://portalen.nrk.no/fotografering-filming-og-publisering-av-bilder-og-video-juridisk/?/lpjpababdmf"
    >
      <ul class="content">
        <li>Bilder tatt på oppdrag for NRK krediteres med NRK som rettighetshaver.</li>
        <li>Bilder NRK kun har bruksrett til, krediteres med den faktiske rettighetshaveren.</li>
        <li>Bilder fra byråer (f.eks. NTB, Reuters) krediteres som regel med byråets navn.</li>
        <li>
          Fotograf eller opphavsperson krediteres normalt som rettighetshaver, med mindre annen
          avtale gjelder.
        </li>
      </ul>
    </InfoBox>
  </div>
  <input
    id="rightsHolder"
    data-testid="Rettighetshaver-input"
    class="org-input"
    type="text"
    value={rightsHolder || ""}
    on:input={onChangeRightsHolder}
    placeholder="NTB, Operaen, NRK…"
    aria-invalid={invalidRightsholder}
  />
  <span class="org-warning">Rettighetshaver må fylles ut</span>
</div>

<style>
  .hidden {
    display: none;
  }

  .content {
    font-size: 12px;
    margin-top: 6px;
    margin-bottom: 6px;
  }
</style>
